import React from "react";
import cx from "classnames";

import ImageElement from "../ImageElement/ImageElement.jsx";

const PageBanner = props => {
  const {
    image,
    overlayBackground,
    title,
    darkText,
    showAccentLine,
    logoImage,
  } = props;

  return (
    <section className="page-banner">
      <figure className="page-banner__figure">
        {image && (
          <ImageElement
            className="js-banner-media"
            srcSet={image}
            sizes={"(min-width: 1440px) 1440px, 100vw"}
          />
        )}
      </figure>
      <div
        className="page-banner__overlay"
        style={{ background: overlayBackground }}
      />
      <div className="page-banner__content">
        <div
          className={cx("page-banner__content-inner", {
            "page-banner__dark-text": darkText,
          })}
        >
          {logoImage && (
            <div className="page-banner__logo">
              <ImageElement
                srcSet={logoImage}
                alt="Logo"
                className="page-banner__logo-image"
              />
            </div>
          )}
          <h1 className="page-banner__title">{title}</h1>
          {showAccentLine && <div className="page-banner__accent-line" />}
        </div>
      </div>
    </section>
  );
};

export default PageBanner;
